import React, { FC } from 'react';
import styled from 'styled-components';
import { LogosFragment } from '../types/graphqlTypes';
import { CardCarouselWrapper } from './CardCarouselWrapper';
import { Img } from './Img';
import { LinkTo } from './LinkTo';
import { Spacer } from './Spacer';
import { Typography } from './Typography';

interface LogosProps extends LogosFragment {
  wide?: boolean;
}

const StyledLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Logos: FC<Omit<LogosProps, '__typename'>> = ({ title, lead, listing, content, wide }) => {
  if (listing.length < 1) {
    return null;
  }

  return (
    <Spacer>
      <CardCarouselWrapper heading={title} lead={lead} content={content} width={wide ? 'extraWide' : 'wide'}>
        {listing.map(({ image, link }, index) => (
          <StyledLogo key={index}>
            {link && (
              <LinkTo to={link}>
                <Typography variant="bodySmall" component="span" visuallyHidden>
                  {image.altText} logo
                </Typography>{' '}
                {image && <Img src={image} />}
              </LinkTo>
            )}
            {!link && <>{image && <Img src={image} />}</>}
          </StyledLogo>
        ))}
      </CardCarouselWrapper>
    </Spacer>
  );
};
